const G = require('generatorics');
const _ = require('lodash');

class Betting {
    // ..and an (optional) custom class constructor. If one is
    // not supplied, a default constructor is used instead:
    // constructor() { }
    constructor() {
      this.selections = [];
      this.sets = [];
      this.each_way = false;
    }

    setEachWay(status) {
        this.each_way = status
    }
    setSelections(selections) {
        this.selections = _.map(selections, 'outcome');
        let markets = _.keyBy(_.map(selections, 'market'), 'id');

        this.selections = _.map(this.selections, (item) => {
            item.ew_price = _.get(markets, item.market_id + '.ew_price')
            return item;
        });
    }

    // (1.5*2) + (1.5*3) + (2*3)
    calculateReturn(permutations) {
        return
        let odds = 0;
        for (let permutation of permutations) {
            if(this.each_way) {
                odds += (_.map(permutation, function(item) {
                    let total = item.odds;
                    if(item.has_ew)
                        total = item.place_odds + item.odds
                    return total;
                })).reduce((a, b)=> a*b, 1)
            } else {
                console.log('systemBetSelection permutation', (_.map(permutation, 'odds')).reduce((a, b)=> parseFloat(a)*parseFloat(b), 1));
                odds += (_.map(permutation, 'odds')).reduce((a, b)=> parseFloat(a)*parseFloat(b), 1)
            }
        }
        
        return odds;
    }



    refreshOdds() {
        return
        let bets_types = [];
        let sets  = this.sets;
        for (let bets in this.sets) {
            let tmp = {};
            tmp.bets = bets;
            tmp.perm_length = _.size(_.first(sets[bets]));
            tmp.selections = this.selections.length;
            tmp.combinations = _.size(sets[bets]);
            tmp.title = `System ${tmp.perm_length}/${tmp.selections}`;
            tmp.name = `System ${tmp.perm_length}/${tmp.selections} (${tmp.combinations} combinations)`;
            tmp.type = `system_${tmp.perm_length}/${tmp.selections}`;
            tmp.permutations = sets[bets];
            if (tmp.perm_length < 2 || tmp.perm_length >= tmp.combinations) {
                continue;
            }
            //console.log('type', type, tmp.type)
            tmp.potential_return = this.calculateReturn(sets[bets]);
            bets_types.push(tmp);
        }

        console.log('refreshOdds', bets_types);

        return bets_types;
    }

    _calculatePotentialReturn(systemBetSelection, eachWay) {
        let permutations = [];
        let odds = 0;
        for (let permutation of G.combination(this.selections, systemBetSelection.perm_length)) {
            permutations.push(_.clone(permutation));
        }
        for (let permutation of permutations) {
            let permutation_odds = (_.map(permutation, 'odds')).reduce((a, b)=> parseFloat(a)*parseFloat(b), 1)
            
            if(eachWay) {
                let win_portion = (_.map(permutation, 'odds')).reduce((a, b)=> parseFloat(a)*parseFloat(b), 1)
                
                let place_portion = _.reduce(permutation, (sum, item) => {
                    return sum * (((parseFloat(item.odds-1))/item.ew_price)+1)
                }, 1)
                permutation_odds = win_portion + place_portion
            }

            odds += permutation_odds
        }
        return odds
    }
    calculatePotentialReturn(systemBetChoices, systemBetSelection, eachWay = false) {        
        systemBetChoices = _.map(systemBetChoices, (systemBetChoice) => {
            if(systemBetChoice && systemBetSelection && systemBetChoice.type == systemBetSelection.type) {
                systemBetChoice.potential_return = this._calculatePotentialReturn(systemBetSelection, eachWay);
            }
            return systemBetChoice
        })

        return systemBetChoices;
    }

    generateSystemBetTypes() {
        let amount  = this.selections.length
        let systemList = [];
        for(let i = 2; i < amount; i++) {
            let tmp = {};
            tmp.bets = i;
            tmp.perm_length = i;
            tmp.selections = this.selections.length;
            tmp.combinations = this._countWays(i, amount);
            tmp.title = `System ${tmp.perm_length}/${tmp.selections}`;
            tmp.name = `System ${tmp.perm_length}/${tmp.selections} (${tmp.combinations} combinations)`;
            tmp.type = `system_${tmp.perm_length}/${tmp.selections}`;
            systemList.push(tmp)
        }
        return systemList;
    }
    
    _f(n) {
        return (n != 1 && n != 0) ? n * this._f(n - 1) : 1;
    }
    
    _countWays(system, amount) {
        return this._f(amount) / this._f(system) / this._f(amount - system);
    }

    generateBetTypes() {
        let sets = []
        window.G = G
        let selections = _.map(this.selections, 'id');
        for(let i = 0; i <= _.size(selections); i++) {
            sets[i] = []
        }
        /*
        for(let i = 0; i <= _.size(selections); i++) {
            let combs = G.combination(this.selections, i);
            sets[i] = Array.from(combs)
        }
        */
        
        for (var subset of G.powerSet(_.map(this.selections), 'id')) {
            if(!sets[subset.length]) {
                sets[subset.length] = []
            }
            sets[subset.length].push(Array.from(subset));
        }
        this.sets = sets
        return this.refreshOdds();
    }
  
}

export default new Betting()